"use client";

import { Mail, MapPin, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ContactDetails() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="contact-details" className="bg-background py-16 lg:py-24" ref={sectionRef}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {}
          <div className="space-y-8">
            <div className={`transition-all duration-[var(--duration-medium)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
              <h2 className="font-display text-3xl lg:text-4xl font-bold text-foreground mb-2">
                Get in Touch
              </h2>
              <p className="text-muted text-lg">
                We're here to answer your questions and support your family.
              </p>
            </div>

            {}
            <div className={`group flex items-start gap-4 transition-all duration-[var(--duration-medium)] delay-100 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary-light flex items-center justify-center group-hover:bg-primary-hover/10 transition-colors duration-[var(--duration-medium)]">
                <Phone className="w-5 h-5 text-primary group-hover:scale-110 transition-transform duration-[var(--duration-medium)]" />
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold text-foreground mb-1">
                  Phone
                </h3>
                <Link to="tel:+13051234567" className="text-muted hover:text-primary transition-colors duration-[var(--duration-fast)]">786-762-2520</Link>
              </div>
            </div>

            {}
            <div className={`group flex items-start gap-4 transition-all duration-[var(--duration-medium)] delay-200 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary-light flex items-center justify-center group-hover:bg-secondary-hover/10 transition-colors duration-[var(--duration-medium)]">
                <Mail className="w-5 h-5 text-secondary group-hover:scale-110 transition-transform duration-[var(--duration-medium)]" />
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold text-foreground mb-1">
                  Email
                </h3>
                <Link to="mailto:info@abawithpassion.com" className="text-muted hover:text-secondary transition-colors duration-[var(--duration-fast)]">
                  info@abawithpassion.com
                </Link>
              </div>
            </div>

            {}
            <div className={`group flex items-start gap-4 transition-all duration-[var(--duration-medium)] delay-300 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-accent-light flex items-center justify-center group-hover:bg-accent-hover/10 transition-colors duration-[var(--duration-medium)]">
                <MapPin className="w-5 h-5 text-accent group-hover:scale-110 transition-transform duration-[var(--duration-medium)]" />
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold text-foreground mb-1">
                  Miami Office
                </h3>
                <p className="text-muted">8700 W Flagler St #470
<div>Miami, FL 33174</div></p>
              </div>
            </div>
          </div>

          {}
          <div ref={mapRef} className={`transition-all duration-[var(--duration-slow)] ${mapVisible ? "opacity-100 blur-0" : "opacity-0 blur-[2px]"}`}>
            <div className="relative w-full h-[400px] lg:h-[500px] rounded-[var(--radius-lg)] overflow-hidden shadow-medium hover:shadow-strong transition-shadow duration-[var(--duration-medium)]">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d230025.2727998969!2d-80.43948595!3d25.7741728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b0a20ec8c111%3A0xff96f271ddad4f65!2sMiami%2C%20FL!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Miami Office Location" className="absolute inset-0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>;
}